/**
 * PLP desktop filters: Columbia-style sticky .facets__form with overflow scroll.
 * Max-height uses remaining viewport from the form's current top so pageY=0
 * still reaches the last filter ("Mostrar más") without scrolling the grid.
 * Wheel over filters is routed to the form (page stays put until ends).
 */
(function () {
  var BOUND = 'lopSidebarScrollBound';
  var BOTTOM_GAP = 8;
  var rafId = 0;

  function readCssPx(styles, name, fallback) {
    var value = parseFloat(styles.getPropertyValue(name));
    return Number.isFinite(value) ? value : fallback;
  }

  function getStickyTop() {
    var root = getComputedStyle(document.documentElement);
    return (
      readCssPx(root, '--header-height', 85) +
      readCssPx(root, '--header-offset', 0) +
      readCssPx(root, '--facets-bar-inner-height', 56)
    );
  }

  /** Shopify theme preview bar (draft) sits fixed at the bottom and must not cover filters. */
  function getBottomObstruction() {
    var preview = document.getElementById('PBarNextFrameWrapper');
    if (!preview) return BOTTOM_GAP;
    var styles = getComputedStyle(preview);
    if (styles.display === 'none' || styles.visibility === 'hidden') return BOTTOM_GAP;
    var height = preview.getBoundingClientRect().height;
    return BOTTOM_GAP + (height > 0 ? Math.ceil(height) : 0);
  }

  function getDesktopFilterForm(node) {
    if (!node || !node.closest) return null;
    if (window.matchMedia('(max-width: 767px)').matches) return null;

    var form = node.closest
      ? node.closest('#Sidebar-Container.facets--sidebar-open .facets__form')
      : null;
    if (!form) return null;

    var container = form.closest('.facets-desktop-container');
    if (!container || getComputedStyle(container).display === 'none') return null;
    return form;
  }

  function clearInlineScrollStyles(form) {
    form.style.removeProperty('position');
    form.style.removeProperty('top');
    form.style.removeProperty('max-height');
    form.style.removeProperty('height');
    form.style.removeProperty('overflow-x');
    form.style.removeProperty('overflow-y');
    form.style.removeProperty('overscroll-behavior');
    form.style.removeProperty('--lop-facets-form-max-height');
  }

  function applyScrollBox(form) {
    if (!form || window.matchMedia('(max-width: 767px)').matches) return;

    var stickyTop = getStickyTop();
    var rect = form.getBoundingClientRect();
    // Remaining viewport from the form's current top (not 100vh - stickyTop).
    // At pageY=0 the form sits below the facets bar, so that shorter height is required
    // for the last filters / "Mostrar más" to be reachable without page scroll.
    var topInViewport = Math.max(0, rect.top);
    var maxHeight = Math.max(
      220,
      Math.floor(window.innerHeight - topInViewport - getBottomObstruction())
    );

    form.style.setProperty('position', 'sticky');
    form.style.setProperty('top', stickyTop + 'px');
    form.style.setProperty('--lop-facets-form-max-height', maxHeight + 'px');
    form.style.setProperty('max-height', maxHeight + 'px');
    form.style.setProperty('height', 'auto');
    form.style.setProperty('overflow-x', 'hidden');
    form.style.setProperty('overflow-y', 'auto');
    form.style.setProperty('overscroll-behavior', 'contain');
  }

  function onWheel(event) {
    var form = getDesktopFilterForm(event.target);
    if (!form) return;

    applyScrollBox(form);

    var maxScroll = form.scrollHeight - form.clientHeight;
    if (maxScroll <= 1) return;

    var atTop = form.scrollTop <= 0;
    var atBottom = form.scrollTop >= maxScroll - 1;
    var scrollingDown = event.deltaY > 0;
    var scrollingUp = event.deltaY < 0;

    if ((scrollingUp && atTop) || (scrollingDown && atBottom)) return;

    event.preventDefault();
    event.stopPropagation();
    form.scrollTop += event.deltaY;
  }

  function refreshAll() {
    if (typeof updateFacetsBarInnerHeight === 'function') {
      updateFacetsBarInnerHeight();
    }

    if (window.matchMedia('(max-width: 767px)').matches) {
      document.querySelectorAll('.facets-desktop-container .facets__form').forEach(clearInlineScrollStyles);
      return;
    }

    document
      .querySelectorAll('#Sidebar-Container.facets--sidebar-open > .facets-desktop-container .facets__form')
      .forEach(applyScrollBox);
  }

  function scheduleRefresh() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = 0;
      refreshAll();
    });
  }

  function init() {
    if (!document.documentElement.dataset[BOUND]) {
      document.documentElement.dataset[BOUND] = 'true';
      document.addEventListener('wheel', onWheel, { passive: false, capture: true });
      window.addEventListener('resize', scheduleRefresh, { passive: true });
      // Recalculate remaining viewport as sticky engages / releases.
      window.addEventListener('scroll', scheduleRefresh, { passive: true });
    }

    refreshAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.lopRefreshFacetsSidebarScroll = refreshAll;
})();
